import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import './date-localize';
import { enLangs } from './locales/en';
import { ruLangs } from './locales/ru';

export const resources = {
  en: enLangs,
  ru: ruLangs,
} as const;

const ns = Object.keys(resources.en);

let deviceLanguage = 'ru';
deviceLanguage = ns.includes(deviceLanguage) ? deviceLanguage : 'en';

i18n.use(initReactI18next).init({
  lng: 'ru',
  ns,
  resources,

  interpolation: {
    prefix: '{{',
    suffix: '}}',
    // Подставляемое значение попадает в текст как есть — тексты интерфейса выводятся обычным
    // текстом, и экранирует их сам React. Иначе знаки значения видны пользователю экранированными.
    escapeValue: false,
  },
});

export const changeI18nLanguage = (language: string) => {
  if (Object.keys(resources).includes(language)) {
    i18n.changeLanguage(language);
  }
};

export default i18n;
